<ng-container *ngIf="typeTemplate !== 'pdtRecomm'; else pdtRecomm">
    <div class="imgWrap">
        <a (click)="onClickProductDetail(product);">
            <img data-sizes="auto" data-src="{{
                    urlWownet + product.filePath + product.fileName
                }}" onerror="this.src='./assets/img/noImage.jpg'" class="lazyload" alt="{{ product.pdtName }}" />
        </a>

        <div class="btns">
            <a (click)="onClickWishList($event)">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                    [attr.fill]="wishYN === 'Y' ? '#FF0000' : 'none'" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path
                        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
                    </path>
                </svg>
            </a>
            <a (click)="onAddToCart($event)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <circle cx="10" cy="20.5" r="1" />
                    <circle cx="18" cy="20.5" r="1" />
                    <path d="M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1" />
                </svg></a>
        </div>
    </div>
    <a (click)="onClickProductDetail(product);">
        <p>{{ product.pdtName }}</p>
        <ng-container *ngIf="isLogin">
            <ng-container *ngIf="userKindCd == 'U10' ">
                <span>{{ product.amt | setComma }}원</span>
            </ng-container>
            <ng-container *ngIf="userKindCd == 'U00' && +product.retailAmt > 0 ">
                <span>{{ product.retailAmt | setComma }}원</span>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!isLogin && +product.retailAmt > 0">
            <span>{{ product.retailAmt | setComma }}원</span>
        </ng-container>
    </a>
</ng-container>

<ng-template #pdtRecomm>
    <div class="num">{{ number }}</div>
    <a (click)="onClickProductDetail(product)" class="prod">
        <div class="imgWrap">
            <a>
                <img data-sizes="auto" data-src="{{ urlWownet + product.filePath + product.fileName }}"
                    onerror="this.src='./assets/img/noImage.jpg'" class="lazyload" alt="{{ product.pdtName }}" /></a>
        </div>
        <div class="prodInfo">
            <p>{{ product.cateName }}</p>
            <h3>{{ product.pdtName }}</h3>
            <ng-container *ngIf="isLogin">
                <ng-container *ngIf="userKindCd == 'U10' ">
                    <span>{{ product.amt | setComma }}원</span>
                </ng-container>
                <ng-container *ngIf="userKindCd == 'U00' && +product.retailAmt > 0 ">
                    <span>{{ product.retailAmt | setComma }}원</span>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!isLogin && +product.retailAmt > 0">
                <span>{{ product.retailAmt | setComma }}원</span>
            </ng-container>
        </div>
    </a>
    <div class="btns">
        <a (click)="onClickWishList($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                [attr.fill]="wishYN === 'Y'  ? '#FF0000' : 'none'" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path
                    d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
                </path>
            </svg>
        </a>
        <a (click)="onAddToCart($event);"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="10" cy="20.5" r="1" />
                <circle cx="18" cy="20.5" r="1" />
                <path d="M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1" />
            </svg></a>
    </div>
</ng-template>
